import { Spinner, SpinnerProps } from "@chakra-ui/react";
import React from "react";

export type VeriSpinnerProps = SpinnerProps;

export const VeriSpinner = (props: VeriSpinnerProps) => (
  <Spinner speed="1s" color="brand.main" {...props} />
);
